module.exports = __webpack_public_path__ + "static/media/owl.2b77c2a5.svg";